<template>
  <footer class="flex justify-between items-center p-4">
    <div></div>
    <div class="flex flex-wrap space-x-2 text-sm justify-center">
      <a
        class="font-medium text-indigo-500 hover:text-indigo-600 dark:hover:text-indigo-400"
        href="https://wizardtales.com/imprint"
        >Imprint</a
      >
      <a
        class="font-medium text-indigo-500 hover:text-indigo-600 dark:hover:text-indigo-400"
        href="https://wizardtales.com/dataprotection"
        >Privacy Policy</a
      >
    </div>
  </footer>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped></style>
